














export default {
  name: 'StatusTabSkeletons',
  props: {
    type: { type: String, default: 'square' }, // 'square' or 'accordion'
    count: { type: Number, default: 6 },
  },
};
